import React from 'react';
import Layout from '../components/Layout';
import Contact from '../components/Contact';
import {graphql} from 'gatsby';

export default function contact(props) {
  return (
    <Layout>
      <Contact
        data={{
          ...props.data.userJson.contact,
          ...props.data.userJson.navbar,
        }}
      />
    </Layout>
  );
}

export const query = graphql`
    query ContactData {
        userJson {
            navbar {
                title
            }
            contact {
                email
                phone
                location
                locationLink
                subtitle
            }
        }
    }
`;
